// Dates « YYYY-MM-DD » calculées en UTC : aucune dérive de fuseau horaire,
// quel que soit le navigateur.

export const WEEKDAYS = [
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
];

const toUtc = (date) => {
  const [year, month, day] = date
    .slice(0, 10)
    .split('-')
    .map((part) => {
      return parseInt(part, 10);
    });
  return Date.UTC(year, month - 1, day);
};

const fromUtc = (time) => {
  return new Date(time).toISOString().slice(0, 10);
};

export const normalizeDate = (date) => {
  if (!date) {
    return null;
  }
  return String(date).slice(0, 10);
};

export const addDays = (date, count) => {
  return fromUtc(toUtc(date) + count * 86400000);
};

export const weekdayOf = (date) => {
  return WEEKDAYS[new Date(toUtc(date)).getUTCDay()];
};

// Les dates « YYYY-MM-DD » se comparent comme des chaînes ; `null` vaut
// l'infini (fin ouverte).
export const minDate = (...dates) => {
  return dates.reduce((acc, date) => {
    if (!date) {
      return acc;
    }
    if (!acc || date < acc) {
      return date;
    }
    return acc;
  }, null);
};

export const maxDate = (...dates) => {
  return dates.reduce((acc, date) => {
    if (!date) {
      return acc;
    }
    if (!acc || date > acc) {
      return date;
    }
    return acc;
  }, null);
};

export const isWithin = (date, start, end) => {
  return (!start || start <= date) && (!end || date <= end);
};

export const formatDay = (date) => {
  return `${date.slice(8, 10)}/${date.slice(5, 7)}`;
};

const WEEKDAY_ORDER = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
];
const WEEKDAY_LABELS = {
  monday: 'lun',
  tuesday: 'mar',
  wednesday: 'mer',
  thursday: 'jeu',
  friday: 'ven',
  saturday: 'sam',
  sunday: 'dim',
};

// « lun-ven », « lun, mer », « mer-ven, dim » : trois jours qui se suivent ou
// plus s'écrivent en intervalle.
export const formatWeekdays = (weekdays) => {
  const runs = [];
  WEEKDAY_ORDER.forEach((weekday, index) => {
    if (!weekdays.includes(weekday)) {
      return;
    }
    const last = runs[runs.length - 1];
    if (last && last.end === index - 1) {
      last.end = index;
    } else {
      runs.push({ start: index, end: index });
    }
  });
  return runs
    .map((run) => {
      const days = WEEKDAY_ORDER.slice(run.start, run.end + 1).map(
        (weekday) => {
          return WEEKDAY_LABELS[weekday];
        },
      );
      return days.length >= 3
        ? `${days[0]}-${days[days.length - 1]}`
        : days.join(', ');
    })
    .join(', ');
};

const hhmm = (time) => {
  return String(time || '').substring(0, 5);
};

// « lun-ven 17:30-21:00 », créneaux séparés par « ; ».
export const formatSlots = (slots) => {
  return slots
    .map((slot) => {
      return `${formatWeekdays(slot.weekdays)} ${hhmm(slot.start_time)}-${hhmm(
        slot.end_time,
      )}`;
    })
    .join(' ; ');
};

// « 12/10 → 29/10 », ou « à partir du 12/10 » pour une fin ouverte.
export const formatRange = (start, end) => {
  if (!end) {
    return `à partir du ${formatDay(normalizeDate(start))}`;
  }
  return `${formatDay(normalizeDate(start))} → ${formatDay(
    normalizeDate(end),
  )}`;
};

// Créneau d'une affectation lue dans care (cases des jours et horaires).
export const slotOfRecord = (record) => {
  return {
    weekdays: WEEKDAY_ORDER.filter((weekday) => {
      return record[weekday] === true;
    }),
    start_time: record.start_time,
    end_time: record.end_time,
  };
};
